import update from 'immutability-helper';
import axios from 'axios';
import I18n from '../locale';
import qwTheatreACL from '../common/client/qwTheatreAccessControlList';
import { displayError } from './app';

const initialState = {
  theatresInSelection: [],
  groups: [],
  offset: 0,
  ps: 10,
  loading: false,
  hasMore: false,
  error: false,
  groupDetail: {
    groupName: '',
    updatedOn: null,
    updatedBy: null,
    theatres: [],
    users: [],
    error: false,
  },
  oldGroupName: '',
  oldTheatresList: [],
};

const UPDATE_THEATRE_IN_GROUP = 'groups/UPDATE_THEATRE_IN_GROUP';
const SET_GROUPS = 'groups/SET_GROUPS';
const SET_LOADING = 'groups/SET_LOADING';
const SET_HAS_MORE = 'groups/SET_HAS_MORE';
const SET_OFFSET = 'groups/SET_OFFSET';
const SET_GROUP_DETAIL_THEATRES = 'groups/SET_GROUP_DETAIL_THEATRES';
const SET_GROUP_DETAIL_NAME = 'groups/SET_GROUP_DETAIL_NAME';
const SET_OLD_GROUP_NAME = 'groups/SET_OLD_GROUP_NAME';
const SET_OLD_THEATRE_LIST = 'groups/SET_OLD_THEATRE_LIST';
const SET_GROUP_COUNT = 'groups/SET_GROUP_COUNT';
const SET_GROUP_DETAILS = 'groups/SET_GROUP_DETAILS';
const SET_ERROR = 'groups/SET_ERROR';

export function updateTheatreInGroup(value) {
  return { type: UPDATE_THEATRE_IN_GROUP, payload: [...value] };
}

function setGroups(groups) {
  return {
    type: SET_GROUPS,
    payload: groups,
  };
}

export function setGroupDetailName(groups) {
  return {
    type: SET_GROUP_DETAIL_NAME,
    payload: groups,
  };
}

function setTheatresInGroup(theatres) {
  return {
    type: SET_GROUP_DETAIL_THEATRES,
    payload: theatres,
  };
}

function setHasMore(hasMore) {
  return {
    type: SET_HAS_MORE,
    payload: hasMore,
  };
}

export function setGroupDetail(groups) {
  return {
    type: SET_GROUP_DETAILS,
    payload: groups,
  };
}

function setGroupCount(count) {
  return {
    type: SET_GROUP_COUNT,
    payload: count,
  };
}

export function setPageLoading(hasMore) {
  return {
    type: SET_LOADING,
    payload: hasMore,
  };
}

function setOffset(offset) {
  return {
    type: SET_OFFSET,
    payload: offset,
  };
}
export function setOldGroupName(name) {
  return {
    type: SET_OLD_GROUP_NAME,
    payload: name,
  };
}
export function setOldTheatresList(value) {
  return {
    type: SET_OLD_THEATRE_LIST,
    payload: value,
  };
}

function setError(error) {
  return {
    type: SET_ERROR,
    payload: error,
  };
}

const { CancelToken } = axios;
let source = CancelToken.source();

export function fetchGroups(
  offset = 0,
  { ps, columnToSort, sortDirection, query } = {},
) {
  return (dispatch) => {
    dispatch(setPageLoading(true));
    dispatch(setError(false));
    if (source) {
      source.cancel();
      source = CancelToken.source();
    }
    qwTheatreACL
      .get('/v1/groups', {
        cancelToken: source.token,
        params: {
          ps: ps || initialState.ps,
          offset,
          sortBy: columnToSort,
          sortDir: sortDirection,
          q: query?.length ? query : undefined,
        },
      })
      .then((response) => {
        dispatch(setGroups(response.data.groups));
        dispatch(setHasMore(response.data.hasMore));
        dispatch(setGroupCount(response.data.groupCount));
        dispatch(setOffset(offset));
        dispatch(setPageLoading(false));
      })
      .catch((error) => {
        if (!axios.isCancel(error)) {
          dispatch(displayError(I18n.t('errorFetchingGroups')));
          dispatch(setGroups([]));
          dispatch(setError(true));
          dispatch(setPageLoading(false));
        }
      });
  };
}
export function fetchGroupsForAdmin(
  offset = 0,
  { ps, columnToSort, sortDirection, query, companyId } = {},
) {
  return (dispatch) => {
    dispatch(setPageLoading(true));
    dispatch(setError(false));
    if (source) {
      source.cancel();
      source = CancelToken.source();
    }
    qwTheatreACL
      .get(`/v1/admin/company/${companyId}/groups`, {
        cancelToken: source.token,
        params: {
          ps: ps || initialState.ps,
          offset,
          sortBy: columnToSort,
          sortDir: sortDirection,
          q: query?.length ? query : undefined,
        },
      })
      .then((response) => {
        dispatch(setGroupCount(response.data.groupCount));
        dispatch(setGroups(response.data.groups));
        dispatch(setHasMore(response.data.hasMore));
        dispatch(setOffset(offset));
      })
      .catch(() => {
        dispatch(displayError(I18n.t('errorFetchingGroups')));
        dispatch(setGroups([]));
        dispatch(setError(true));
      })
      .finally(() => {
        dispatch(setPageLoading(false));
      });
  };
}

export function fetchTheatresInGroup(groupId) {
  return (dispatch) => {
    dispatch(setPageLoading(true));
    dispatch(setError(false));
    dispatch(setGroupDetail({ updatedBy: null, updatedOn: null }));
    qwTheatreACL
      .get(`/v1/groups/${groupId}/theatres`)
      .then((response) => {
        dispatch(setTheatresInGroup(response.data.theatres));
        dispatch(setGroupDetailName(response.data.name));
        dispatch(
          setGroupDetail({
            updatedBy: [
              response.data?.updatedBy?.name,
              response.data?.updatedBy?.lastName,
            ]
              .filter(Boolean)
              .join(' '),
            updatedOn: response.data.updatedAt,
          }),
        );
      })
      .catch(() => {
        dispatch(displayError(I18n.t('errorFetchingGroups')));
        dispatch(setTheatresInGroup([]));
        dispatch(setError(true));
      })
      .finally(() => {
        dispatch(setPageLoading(false));
      });
  };
}
export function fetchTheatresInGroupForAdmin(groupId) {
  return (dispatch) => {
    dispatch(setPageLoading(true));
    dispatch(setError(false));
    dispatch(setGroupDetail({ updatedBy: null, updatedOn: null }));
    qwTheatreACL
      .get(`/v1/admin/groups/${groupId}/theatres`)
      .then((response) => {
        dispatch(setTheatresInGroup(response.data.theatres));
        dispatch(setGroupDetailName(response.data.name));
        dispatch(
          setGroupDetail({
            updatedBy: [
              response.data?.updatedBy?.name,
              response.data?.updatedBy?.lastName,
            ]
              .filter(Boolean)
              .join(' '),
            updatedOn: response.data.updatedAt,
          }),
        );
      })
      .catch(() => {
        dispatch(displayError(I18n.t('errorFetchingGroups')));
        dispatch(setTheatresInGroup([]));
        dispatch(setError(true));
      })
      .finally(() => {
        dispatch(setPageLoading(false));
      });
  };
}
export function fetchTheatresInGroupForEdit(groupId) {
  return (dispatch) => {
    dispatch(setPageLoading(true));
    qwTheatreACL
      .get(`/v1/groups/${groupId}/theatres`)
      .then((response) => {
        dispatch(updateTheatreInGroup(response.data.theatres));
        dispatch(setOldTheatresList(response.data.theatres));
        dispatch(setOldGroupName(response.data.name));
      })
      .catch(() => {
        dispatch(displayError(I18n.t('errorFetchingGroups')));
        dispatch(setTheatresInGroup([]));
        dispatch(setOldGroupName(''));
      })
      .finally(() => {
        dispatch(setPageLoading(false));
      });
  };
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_THEATRE_IN_GROUP:
      return update(state, { theatresInSelection: { $set: action.payload } });
    case SET_GROUPS:
      return update(state, { groups: { $set: action.payload } });
    case SET_GROUP_DETAIL_THEATRES:
      return update(state, {
        groupDetail: { theatres: { $set: action.payload } },
      });
    case SET_GROUP_DETAIL_NAME:
      return update(state, {
        groupDetail: { groupName: { $set: action.payload } },
      });
    case SET_LOADING:
      return update(state, { loading: { $set: action.payload } });
    case SET_HAS_MORE:
      return update(state, { hasMore: { $set: action.payload } });
    case SET_OFFSET:
      return update(state, { offset: { $set: action.payload } });
    case SET_OLD_GROUP_NAME:
      return update(state, { oldGroupName: { $set: action.payload } });
    case SET_OLD_THEATRE_LIST:
      return update(state, { oldTheatresList: { $set: [...action.payload] } });
    case SET_GROUP_COUNT:
      return update(state, { groupCount: { $set: action.payload } });
    case SET_GROUP_DETAILS:
      return update(state, {
        groupDetail: {
          updatedBy: { $set: action.payload.updatedBy },
          updatedOn: { $set: action.payload.updatedOn },
        },
      });
    case SET_ERROR:
      return update(state, { error: { $set: action.payload } });
    default:
      return state;
  }
}
